import React from 'react';
import {Link} from 'react-router-dom';
import {Home, ArrowLeft} from 'lucide-react';

export const NotFound = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="max-w-md w-full text-center">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-gray-300">404</h1>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h2>
                    <p className="text-gray-600">Sorry, we couldn't find the page you're looking for.</p>
                </div>

                <div className="space-y-3">
                    <Link to="/" className="btn btn-primary w-full">
                        <Home className="w-4 h-4 mr-2" />
                        Go Home
                    </Link>
                    <button onClick={() => window.history.back()} className="btn btn-secondary w-full">
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};
